import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import SvgIcon from '../../../SvgIcon'
import { breakpoints } from '@measures/responsive'

const additionalStyles = css`
  @media ${breakpoints.tablet} {
    width: 18px;
    height: 18px;
  }
`

const StyledSvgIcon = styled(SvgIcon)`
  margin-right: 10px;
`

const Icon: FunctionComponent = () => (
  <StyledSvgIcon
    iconName="gallery-video"
    size={19}
    additionalStyles={additionalStyles}
  />
)

export default Icon
